import React, {useEffect, useState} from 'react';
import {Button, Col, Form, FormGroup, Input, Row} from "reactstrap";
import {useHistory} from 'react-router-dom';
import CropImage from './cropImage';
import {getDownloadURL, getStorage, ref, uploadBytes} from "firebase/storage";
import imageIcon from "../../assets/img/brand/image1.png"

const PopupForm = ({ eventData, setIsEditForm, setMainData, mainEventID }) => {
    const [localImage, setLocalImage] = useState(null);
    const [logo, setLogo] = useState(null);
    const [localVideo, setLocalVideo] = useState(null);
    const [video, setVideo] = useState(null);
    const [imageError, setImageError] = useState(null);
    const [localEventData, setLocalEventData] = useState({});
    const [loading, setLoading] = useState(true);
    const [minDate, setMinDate] = useState('');
    const history = useHistory();

    useEffect(() => {


        const currentDate = new Date().toISOString().slice(0, 10);
        setMinDate(currentDate);
        setLogo(eventData?.logo);
        setVideo(eventData?.introVideo)
        setLocalEventData(eventData);
        setTimeout(() => {
            setLoading(false);
        }, 1000)
    }, []);

    useEffect(() => {
        if (localEventData.hasOwnProperty("assessmentName"))
            setLocalEventData({ ...localEventData, logo: logo });
    }, [logo]);

    const saveInfo = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {

            const img = await addUrl();
            const video = await videoUrl();


            setLocalEventData({
                ...localEventData,
                logo: img,
                introVideo: video

            });
            await setMainData({
                ...localEventData,
                logo: img,
                introVideo: video

            });
            setLoading(false);
        } catch (e) {

            setLoading(false);
        }
    }

    const addUrl = async () => {


        if (typeof logo === "string" && !logo.includes("firebase")) {

            const _file = await urltoFile(logo, `${mainEventID}logo.png`, 'image/png');

            const storage = getStorage()
            const imageRef = ref(storage, `${mainEventID}logo`);
            const data = await uploadBytes(imageRef, _file);

            const downloadUrl = await getDownloadURL(data.ref);

            return downloadUrl;
        } else {
            return logo;
        }
    };
    const videoUrl = async () => {
        const storage = getStorage()
        const videoRef = ref(storage, `${mainEventID}video`);
        const videoUpload = await uploadBytes(videoRef, video);
        return await getDownloadURL(videoUpload.ref);
    }


    const urltoFile = (url, filename, mimeType) => {
        return (fetch(url)
            .then(function (res) {
                return res.arrayBuffer();
            })
            .then(function (buf) {
                return new File([buf], filename, { type: mimeType });
            })
        );
    }



    const assessmentSet = () => {


        localStorage.setItem('eventId', mainEventID)
        history.push(`/admin/leaderboard/${mainEventID}`)

    }
    return (
        <>
            {loading ? (
                <div className="text-center w-100 py-5 my-5">
                    <div className="spinner-border spinner-border-lg" role="status">
                        <span className="sr-only">Loading...</span>
                    </div>
                </div>
            ) : <Form className="overflow-hidden" onSubmit={saveInfo}>
                <Row>
                    <Col>
                        <FormGroup className="d-flex align-items-center justify-content-between">
                            <label htmlFor="assessmentName" className=" textColor ">Assessment
                                Name</label>
                            <Input
                                className="plainInput  w-50"
                                type="text"
                                required
                                maxLength={20}
                                value={localEventData?.assessmentName}
                                onChange={(e) => {
                                    setLocalEventData({ ...localEventData, assessmentName: e.target.value })
                                }}
                                id="eventName"
                                placeholder="Enter name of Assessment"
                            />
                        </FormGroup>
                        <FormGroup className="d-flex align-items-center justify-content-between">
                            <label htmlFor="assessmentName" className=" textColor ">Assessment
                                for</label>
                            <Input
                                className="plainInput  w-50"
                                type="text"
                                required
                                maxLength={20}
                                value={localEventData?.assessmentFor}
                                onChange={(e) => {
                                    setLocalEventData({ ...localEventData, assessmentFor: e.target.value })
                                }}
                                id="eventName"
                                placeholder="Enter name of Assessment"
                            />
                        </FormGroup>
                        <FormGroup>
                            <FormGroup className='d-flex justify-content-between'>
                                <label for="exampleSelect">
                                    Package Type
                                </label>
                                <Input
                                    id="exampleSelect"
                                    className='w-50'
                                    name="select"
                                    type="select"
                                    value={eventData.packageType}
                                    onChange={(e) => {
                                        setLocalEventData({ ...localEventData, packageType: e.target.value })
                                    }}
                                >
                                    <option value="basic">
                                        Basic
                                    </option>
                                    <option value="premium">
                                        Premium
                                    </option>
                                    <option value="standard">
                                        Standard
                                    </option>
                                    <option value='business'>
                                        Business
                                    </option>

                                </Input>
                            </FormGroup>
                        </FormGroup>
                        <FormGroup className="d-flex justify-content-between align-items-center">
                            <label className="textColor  ">Launch Date</label>
                            <Input
                                className="dateInput  w-50"
                                // required
                                // disabled={loading === "pending"}
                                min={minDate}
                                type="date"
                                value={localEventData.LaunchDate}
                                onChange={(e) => {
                                    setLocalEventData({ ...localEventData, LaunchDate: e.target.value })
                                }}
                                id="date"
                                placeholder="Date"
                            />
                        </FormGroup>
                        <FormGroup className="d-flex justify-content-between align-items-center">
                            <label className="textColor  ">Closing Date</label>
                            <Input
                                className="dateInput  w-50"
                                // required
                                // disabled={loading === "pending"}
                                min={minDate}
                                type="date"
                                value={localEventData.closingDate}
                                onChange={(e) => {
                                    setLocalEventData({ ...localEventData, closingDate: e.target.value })
                                }}
                                id="date"
                                placeholder="Date"
                            />
                        </FormGroup>

                        <FormGroup>
                            <div
                                className="  d-flex align-items-start justify-content-between">
                                <div>
                                    <label className="textColor">Client Logo</label>
                                    <div className="w-75 ">
                                        {imageError === "left" &&
                                            <p className="text-danger mb-0">Please Select image less than
                                                1mb</p>}
                                        <span
                                            className="text-secondary">(Image should be 340px x 60px or 17 : 3)</span>
                                    </div>
                                </div>
                                <div style={{ width: "59%", minHeight: "auto" }}
                                    className="imageBg py-1 d-flex justify-content-center">
                                    <label className="imageInput leftLogo"
                                        role="button">
                                        <img src={localImage ? localImage : logo ? logo : imageIcon}
                                            alt=""
                                            height={localImage ? 100 : logo ? 100 : 80}
                                            width={localImage ? 100 : logo ? 100 : 80}
                                        />
                                        {!logo &&
                                            <span
                                                className={`ms-4 ${!logo && 'text-muted'}`}>{!logo && "Upload"}</span>
                                        }
                                        <CropImage aspectRatio={1} stateSetImage={setLogo} setError={setImageError}
                                            imageLocation="left"
                                            setLocal={setLocalImage} />
                                    </label>
                                </div>
                            </div>
                        </FormGroup>
                        <FormGroup className='d-flex justify-content-between '>

                            <label>Intro Video</label>
                            <div className="me-5">
                                <label htmlFor="#formFile">
                                    <div className="border-file">Choose a video</div>
                                </label>
                                <Input
                                    accept="video/mp4,video/x-m4v,video/*"
                                    className="form-control d-none"
                                    type="file"
                                    id="#formFile"
                                    onChange={(e) => {
                                        setVideo(e.target.files[0]);
                                        setLocalVideo(URL.createObjectURL(e.target.files[0]));
                                    }}
                                    name="upload file"
                                />
                                <span id="videoName" />
                                {typeof video !== "object" ? (
                                    <video
                                        src={video}
                                        className='d-block'
                                        width="100"
                                        type="video/mp4"
                                        height="50"
                                    />
                                ) : (
                                    localVideo &&
                                    <video
                                        src={localVideo}
                                        className='d-block'
                                        width="100"
                                        type="video/mp4"
                                        height="50"
                                    />
                                )}
                            </div>



                        </FormGroup>

                    </Col>
                </Row>
                <div className={`mb-2 mx-2 d-flex justify-content-between`}>
                    <div>
                        {mainEventID &&
                            <Button color='primary' onClick={assessmentSet}>Edit Configrations</Button>}
                    </div>
                    <div>

                        <Button className="btn-success mx-1 " type="submit">Save</Button>
                        <Button className="btn-danger " type="button" onClick={() => {
                            setIsEditForm(false)
                        }}>Cancel</Button>
                    </div>
                </div>
            </Form>}
        </>
    );
};

export default PopupForm;
